import React, { useEffect, useState } from "react";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import {
  Box,
  TableCell,
  TableRow,
  IconButton,
  TextField,
  Button,
  Typography,
} from "@mui/material";

import { Edit, Save, Delete, Add, Close } from "@mui/icons-material";

import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";

import { useSelector } from "react-redux";
import { updateSurveySettingAction } from "../../../../store/reducers/settingSlice";
import { useDispatch } from "react-redux";

interface SurveyLinkedItemProps {
  setDirty: (dirty: boolean) => void;
  isDirty: boolean;
}

const SurveyLinkedItem: React.FC<SurveyLinkedItemProps> = ({ setDirty, isDirty }) => {
  const dispatch = useDispatch();
  const { surveySettingResponse } = useSelector((state: any) => state.setting);

  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Move Equipment", align: "left" },
    { label: "Action", align: "center" },
  ];

  const [items, setItems] = useState<any[]>([]);
  const [editIndex, setEditIndex] = useState<number | null>(null);

  useEffect(() => {
    if (surveySettingResponse?.linked_items) {
      setItems(surveySettingResponse.linked_items);
    }
  }, [surveySettingResponse]);

  /* ---------- HANDLE INPUT CHANGE ---------- */

 const handleChange = (index: number, value: string) => {
  const updated = [...items];
  // clone the object at this index
  updated[index] = { ...updated[index], name: value };
  setItems(updated);
  setDirty(true);
};

  /* ---------- ADD ROW AT TOP ---------- */

  const handleAddRow = () => {
    const newRow = { id: "", name: "" };
    const updated = [newRow, ...items];
    setItems(updated);
    setEditIndex(0);
    setDirty(true);
  };

  const preparePayload = (updatedItems: any[]) => {
    const payload = {
      ...surveySettingResponse,
      linked_items: updatedItems,
    };

    console.log("Final Submit Payload:", payload);

    return payload;
  };

  /* ---------- SAVE ---------- */

  const handleSave = (index: number) => {
    if (!items[index].name.trim()) return;
    setEditIndex(null);
    const payload = preparePayload(items);
    dispatch(updateSurveySettingAction(payload));
    setDirty(false);
  };

  /* ---------- CANCEL ---------- */

  const handleCancel = () => {
    setItems(surveySettingResponse?.linked_items || []);
    setEditIndex(null);
    setDirty(false);
  };

  /* ---------- DELETE ---------- */

  const handleDelete = (index: number) => {
    const item = items[index];
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
    setDirty(true);
    if (!item.id) {
      return;
    }
    const payload = preparePayload(updated);
    dispatch(updateSurveySettingAction(payload));
    setDirty(false);
  };

  return (
    <>
      <Box
        sx={{
          bgcolor: "#fff",
          height: { xs: "auto", sm: "60vh" },
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1, // margin bottom
            padding: "6px 8px",
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: "600" }}>
            Survey Move Equipment
          </Typography>
          <Button
            variant="contained"
            size="small"
            startIcon={<Add />}
            onClick={handleAddRow}
          >
            Add Item
          </Button>
        </Box>
        <TableDesign
          tableHeadings={tableHeadings}
          tableHeadColor={"#02906f"}
          cellColor={"#fff"}
          pagination={null}
          isLoader={false}
          stickyHeader={true}
          filterOption={null}
          setFilterOption={() => {}}
          extraCSS={{
            height: "100%",
          }}
        >
          {/* DATA ROWS */}
          {items?.length > 0 ? (
            items.map((item: any, idx: number) => (
              <TableRow
                key={idx}
                sx={{
                  height: "36px",
                }}
              >
                <TableCell
                  sx={{
                    padding: "4px 8px",
                    fontSize: "13px",
                  }}
                >
                  {idx + 1}
                </TableCell>

                <TableCell
                  sx={{
                    padding: "4px 8px",
                  }}
                >
                  <TextField
                    value={item.name}
                    fullWidth
                    size="small"
                    disabled={editIndex !== idx}
                    onChange={(e) => handleChange(idx, e.target.value)}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "30px",
                        fontSize: "13px",
                      },
                      "& .MuiInputBase-input": {
                        padding: "4px 8px",
                      },
                    }}
                  />
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    padding: "0px",
                  }}
                >
                  {editIndex === idx ? (
                    <>
                      <IconButton
                        color="success"
                        size="small"
                        onClick={() => handleSave(idx)}
                      >
                        <Save fontSize="small" />
                      </IconButton>

                      <IconButton
                        color="warning"
                        size="small"
                        onClick={handleCancel}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </>
                  ) : (
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() => setEditIndex(idx)}
                    >
                      <Edit fontSize="small" />
                    </IconButton>
                  )}

                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => handleDelete(idx)}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Box>
    </>
  );
};

export default SurveyLinkedItem;
